import { PageLink } from 'assets/layout/core'

export const breadcrumbCreate: PageLink[] = [
  {
    title: 'Tipos de cardápio',
    path: '/commercial/menuFoodTypes',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
